<template>
  <div>
    <template v-if="getUser.super_admin">
      <ReportPromoSAGlobal/>
    </template>
  </div>
</template>

<script>
import TitlePage from "../components/utils/TitlePage";
import ReportPromoSAGlobal from "@/components/admin/ReportPromoSAGlobal.vue";
import {mapGetters} from "vuex";

export default {
  name: 'ReportPromoSuperAdmin',
  components: {ReportPromoSAGlobal,TitlePage},
  data() {
    return {

    };
  },

  computed: {
    ...mapGetters({
      'getUser': 'user/getUser',
    }),
  },
  methods: {

  },
  mounted() {

  },

}
</script>